import { InjectionToken, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ShellService } from '@mynexus/mfe-core';
import { ProductNames } from '@mynexus/mynexus-ui-lib';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
export const API_BASE_DMEPOS_URL = new InjectionToken<string>('API_BASE_DMEPOS_URL');
export const API_BASE_FEATURE_URL = new InjectionToken<string>('API_BASE_FEATURE_URL');
export const API_BASE_PACIM_URL = new InjectionToken<string>('API_BASE_PACIM_URL');
export const API_BASE_PLATFORM_URL = new InjectionToken<string>('API_BASE_PLATFORM_URL');

@NgModule({ 
    declarations: [],
    exports: [CommonModule],
    imports: [CommonModule],
    providers: [
        ShellService,
        {
            provide: API_BASE_URL,
            useFactory: (shellService: ShellService) => shellService.getBaseUrlFor(ProductNames.HomeHealth),
            deps: [ShellService]
        },
        {
            provide: API_BASE_DMEPOS_URL,
            useFactory: (shellService: ShellService) => shellService.getBaseUrlFor(ProductNames.DMEPOS),
            deps: [ShellService]
        },
        {
            provide: API_BASE_FEATURE_URL,
            useFactory: (shellService: ShellService) => shellService.getBaseUrlFor(ProductNames.HomeHealth) + '/',
            deps: [ShellService]
        },
        {
            provide: API_BASE_PACIM_URL,
            useFactory: (shellService: ShellService) => shellService.getBaseUrlFor(ProductNames.PACIM),
            deps: [ShellService]
        },
        {
            provide: API_BASE_PLATFORM_URL,
            useFactory: (shellService: ShellService) => shellService.getBaseUrlFor('Platform'),
            deps: [ShellService]
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class CoreModule {}
